import dayjs from 'dayjs'
import { useEffect, useMemo, useState } from 'react'
import Modal from 'react-modal'
import { useDispatch, useSelector } from 'react-redux'
import { z } from 'zod'
import { AgentModel } from '../../models/agent'
import { ChangeBranchModalProps } from '../../models/component'
import * as errorActions from '../../redux/actions/error.action'
import * as staffActions from '../../redux/actions/staff.action'
import { RootReducers } from '../../redux/reducers'
import { BranchList } from '../branchList'
import { WatDatePicker } from '../datePicker'
import { LoadingOverlay } from '../loadingOverlay'
import classes from './ModalChangeBranch.module.css'

const formSchema = z.object({
  email: z.string().email(),
  branchId: z.number(),
  endDate: z.string().date('โปรดระบุวันสิ้นสุด'),
  startDate: z.string().date('โปรดระบุวันเริ่มต้น'),
  createBy: z.string().min(1)
})

export const ChangeBranchModal: React.VFC<ChangeBranchModalProps> = ({
  selectedData,
  handleCancelbutton,
  onSuccess,
  isOpenModal
}) => {
  const dispatch = useDispatch()
  const loginState = useSelector((state: RootReducers) => state.loginReducer)
  const [submitting, setSubmitting] = useState(false)

  const setInitialFormState = () => {
    return {
      email: selectedData?.staffemail,
      branchId: selectedData?.regularBranchId || 1,
      startDate: '',
      endDate: '',
      createBy: loginState?.account?.agentInfo.name ?? ''
    }
  }

  const [error, setError] = useState<any>({})
  const [form, setForm] = useState<z.infer<typeof formSchema>>(setInitialFormState())

  const handleOnChangeBranch = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { value: branchId } = e.target
    setForm(prev => ({ ...prev, branchId: +branchId }))
  }

  const validateForm = () => {
    return formSchema.safeParse(form)
  }

  const handleChangeStartDate = (chrisDate: any) => {
    setForm(prev => ({ ...prev, startDate: chrisDate }))
  }

  const handleChangeEndDate = (chrisDate: any) => {
    setForm(prev => ({ ...prev, endDate: chrisDate }))
  }

  const ErrorMessage = ({ name }: { name: string }) => {
    const findError = error[name]?._errors
    if (findError?.length > 0) {
      return <div className={classes.ErrorMessage}>{findError[0]}</div>
    } else {
      return null
    }
  }

  const onSubmit = async () => {
    const { success, data, error } = validateForm()
    if (success) {
      try {
        setError({})
        setSubmitting(true)
        const resp = await dispatch(staffActions.newBranchMovement(data))
        onSuccess(resp)
      } catch (error) {
        handleCancelbutton()
        dispatch(errorActions.setError(error))
      } finally {
        setSubmitting(false)
      }
    } else {
      const formated = error.format()
      setError(formated)
    }
  }

  useEffect(() => {
    setForm(prev => ({ ...prev, ...setInitialFormState() }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedData])

  const isDisableBtn = useMemo(() => !validateForm().success, [form])

  return (
    <Modal
      isOpen={isOpenModal}
      className="modal-cancel"
      style={{
        content: {
          width: 570
        },
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(24, 48, 40, 0.9)'
        }
      }}
      ariaHideApp={false}
    >
      {submitting && <LoadingOverlay />}
      <div className="modal-cancel-content">
        <div>
          <div className="modal-cancel-header-text">
            เปลี่ยนสาขา: {selectedData?.staffname} สาขา: {selectedData?.regularbranchname}{' '}
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 10,
              marginTop: 20
            }}
          >
            <div>สาขาใหม่</div>
            <BranchList
              isGetBranchId={true}
              branchId={selectedData?.regularBranchId?.toString?.()}
              agentData={loginState.account?.agentInfo as AgentModel}
              onChange={handleOnChangeBranch}
            />
          </div>
          <div className={classes.DateWrapper}>
            <div>
              <div className={classes.FormLabel}>วันที่เริ่มต้น วัน/เดือน/ปี (พ.ศ.)</div>
              <WatDatePicker
                name="startDate"
                dateFormat={'yyyy-MM-dd'}
                displayFormat={'DD/MM/YYYY'}
                clearable={false}
                minDate={dayjs()}
                maxDate={dayjs().add(5, 'year')}
                onChange={handleChangeStartDate}
              />
              <ErrorMessage name="startDate" />
            </div>
            <div>
              <div className={classes.FormLabel}>วันที่สิ้นสุด วัน/เดือน/ปี (พ.ศ.)</div>
              <WatDatePicker
                name="endDate"
                dateFormat={'yyyy-MM-dd'}
                displayFormat={'DD/MM/YYYY'}
                clearable={false}
                minDate={form.startDate || dayjs().add(1, 'day')}
                maxDate={dayjs().add(5, 'year')}
                onChange={handleChangeEndDate}
              />
              <ErrorMessage name="endDate" />
            </div>
          </div>
        </div>
        <div className="modal-cancel-group-button">
          <button className="cancel-transaction-button" onClick={handleCancelbutton}>
            ยกเลิก
          </button>{' '}
          &nbsp;
          <button className="confirm-transaction-button" onClick={onSubmit} disabled={isDisableBtn}>
            ยืนยัน
          </button>
        </div>
      </div>
    </Modal>
  )
}
